export default "<div class=\"cont-table\" [ngClass]=\"{ 'noborde' : border == false }\">\n  <ng-content></ng-content>\n</div>";